import $ from "jquery";
import Swiper from "swiper";
import { Navigation, A11y, Keyboard } from "swiper/modules";
import * as bs from "bootstrap";
import { video } from "../functions/video";

const vgOptions = {};
const allSlides = [];
const allKeywords = [];
const base = window.location.href.split("?")[0];
const baseDataLayer = {
  event: "gtmEvent",
  event_name: "video_interaction",
  event_category: "HTML5 Video",
};

// ###################################################################################################
// # FUNCTIONS #######################################################################################
// ###################################################################################################

const hideEmptyCategories = () => {
  document.querySelectorAll(".vg_category").forEach((category) => {
    category.classList.remove("hide-category");
    let height = category.querySelector(".vg_slider").offsetHeight;
    if (height === 0) category.classList.add("hide-category");
  });
};

const checkEmptyCategories = () => {
  let visibleCategories = 0;
  $(".vg_category").each(function () {
    if ($(this).is(":visible")) visibleCategories += 1;
  });
  if (visibleCategories === 0) {
    $(".empty-state").show();
  } else {
    $(".empty-state").hide();
  }
};

const getLowerCaseString = (data) => {
  let string = data.toString().toLowerCase();
  string = string.toLowerCase();
  return string;
};

const updateButtonPositions = () => {
  let element = document.querySelector(".ref-container");
  if (element) {
    let rect = element.getBoundingClientRect();
    let left = rect.left + window.scrollX;
    let right = rect.right + window.scrollX;

    vgOptions.left = left;
    vgOptions.right = right;

    // vgOptions.before = left - 30;
    // vgOptions.after = left - 30;

    // console.log("left", left);
    if (left - 30 > 80) {
      vgOptions.before = left - 30;
      vgOptions.after = left - 30;
    } else {
      vgOptions.before = 65;
      vgOptions.after = 65;
    }

    let prevPos = left - 30 - 60;
    let nextPos = right + 30;

    if (window.innerWidth < 1350) {
      prevPos = 5;
      nextPos = window.innerWidth - 5 - 60;
    }

    if (window.innerWidth < 992) {
      //   prevPos = 5;
      //   nextPos = window.innerWidth - 5 - 60;
      vgOptions.before = 0;
      vgOptions.after = 0;
    }

    if (window.innerWidth < 768) {
      // prevPos = 5;
      nextPos = window.innerWidth - 5 - 40;
    }

    $(".vg_category .swiper-button-prev").css("left", `${prevPos}px`);
    $(".vg_category .swiper-button-next").css("left", `${nextPos}px`);
    $(window).trigger("updateSlider");
  }
  return 0;
};

const checkSlideVisibility = (swiper) => {
  let slides = swiper.slides;
  let count = 0;
  let inViewport = 0;

  slides.forEach((slide) => {
    let $slide = $(slide);
    let slideRect = slide.getBoundingClientRect();
    let viewLeft = vgOptions.left - 31;
    let viewRight = vgOptions.right + 31;

    if (window.innerWidth < 1350) {
      viewLeft = 0;
      viewRight = window.innerWidth + 1;
    }

    if (slideRect.left >= viewLeft && slideRect.right <= viewRight + 20) {
      inViewport = inViewport + 1;
      $slide.addClass("in-viewport");
    } else {
      $slide.removeClass("in-viewport");
    }

    count++;
  });

  return count === inViewport;
};

const filterCategories = () => {
  let $this = $(".btn.category-select.active");
  if ($this.length === 0) {
    $(".vg_category").removeClass("hide");
  } else {
    let data = $this.data();
    $(".vg_category").each(function () {
      let $category = $(this);
      let cData = $category.data();
      if (cData.uid === data.uid) {
        $category.removeClass("hide");
      } else {
        $category.addClass("hide");
      }
    });
  }
  hideEmptyCategories();
  checkEmptyCategories();
};

const filterVideos = (keywords, country) => {
  let visibleSlides = 0;

  // console.log("filterVideos", keywords, country);

  allSlides.forEach((slide) => {
    let showCountry = false;
    let showKeywords = false;

    if (!isNaN(country)) {
      // console.log("slide.countries", slide.countries.includes(country));
      if (slide.countries.includes(country)) showCountry = true;
    } else {
      showCountry = true;
    }

    if (keywords.length > 0) {
      // console.log("slide.keywords", slide.keywords.includes(keywords));
      if (slide.keywords.includes(keywords)) showKeywords = true;
      // console.log("slide.title", slide.title.includes(keywords));
      if (slide.title.includes(keywords)) showKeywords = true;
    } else {
      showKeywords = true;
    }

    if (showCountry && showKeywords) {
      if (slide.visible) $(`#${slide.id}`).remove();
      $(`#${slide.parent} .swiper-wrapper`).append(slide.html);
      slide.visible = true;
      visibleSlides++;
    } else {
      if (slide.visible) $(`#${slide.id}`).remove();
      slide.visible = false;
    }
  });

  visibleSlides > 0 ? $(".empty-state").hide() : $(".empty-state").show();

  $(window).trigger("resetSlider");
  filterCategories();
  hideEmptyCategories();
  checkEmptyCategories();
};

const resetVideos = () => {
  allSlides.forEach((slide) => {
    if (slide.visible) $(`#${slide.id}`).remove();
    $(`#${slide.parent} .swiper-wrapper`).append(slide.html);
    slide.visible = true;
  });
  $("#vg_country").val("");
  $("#vg_keywords").val("");
  $(window).trigger("resetSlider");
  $(".empty-state").hide();
  filterCategories();
  hideEmptyCategories();
  checkEmptyCategories();
};

const autocomplete = (inp, arr) => {
  let currentFocus;

  let addActive = (x) => {
    if (!x) return false;
    removeActive(x);
    if (currentFocus >= x.length) currentFocus = 0;
    if (currentFocus < 0) currentFocus = x.length - 1;
    x[currentFocus].classList.add("autocomplete-active");
  };

  let removeActive = (x) => {
    for (var i = 0; i < x.length; i++) {
      x[i].classList.remove("autocomplete-active");
    }
  };

  let closeAllLists = (elmnt) => {
    let x = document.getElementsByClassName("autocomplete-items");
    for (let i = 0; i < x.length; i++) {
      if (elmnt != x[i] && elmnt != inp) {
        x[i].parentNode.removeChild(x[i]);
      }
    }
  };

  inp.addEventListener("input", function (e) {
    let a;
    let b;
    let i = 0;
    let val = this.value;
    closeAllLists();
    if (!val) return false;
    currentFocus = -1;

    a = document.createElement("DIV");
    a.setAttribute("id", this.id + "autocomplete-list");
    a.setAttribute("class", "autocomplete-items");

    this.parentNode.appendChild(a);

    for (i = 0; i < arr.length; i++) {
      if (arr[i].toUpperCase().includes(val.toUpperCase())) {
        b = document.createElement("DIV");
        let highlighted = arr[i].replace(
          new RegExp(val, "gi"),
          (match) => `<strong>${match}</strong>`
        );
        b.innerHTML = highlighted;
        b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
        b.addEventListener("click", function (e) {
          inp.value = this.getElementsByTagName("input")[0].value;
          closeAllLists();
        });
        a.appendChild(b);
      }
    }
  });

  inp.addEventListener("keydown", function (e) {
    var x = document.getElementById(this.id + "autocomplete-list");
    if (x) x = x.getElementsByTagName("div");
    if (e.keyCode == 40) {
      currentFocus++;
      addActive(x);
    } else if (e.keyCode == 38) {
      currentFocus--;
      addActive(x);
    } else if (e.keyCode == 13) {
      e.preventDefault();
      if (currentFocus > -1) {
        if (x) x[currentFocus].click();
      }
    }
  });

  document.addEventListener("click", (e) => closeAllLists(e.target));
};

// ###################################################################################################
// # INIT ############################################################################################
// ###################################################################################################

export const init = () => {
  // delete all $("#vg_modal") except one
  let foundModal = false;
  $(".vg_modal").each(function (index) {
    if (foundModal) $(this).remove();
    if ($(this).attr("id") === "vg_modal") foundModal = true;
  });

  let $modal = $("#vg_modal");
  let $modalBody = $modal.find(".modal-body");
  let $modalContent = $modal.find(".modal-content");
  let $modalClose = $modal.find(".modal-close");

  $modalClose.on("click", function (e) {
    $modal.modal("hide");
    $modalBody.html("");
  });

  $(window).on("resize", () => updateButtonPositions());

  // ----------------------------------------------
  // init sliders
  // ----------------------------------------------
  $(".vg_category").each(function (e) {
    let $this = $(this);
    let cID = $this.attr("id");
    let data = $this.data();
    let id = $this.find(".vg_slider").attr("id");
    let $wrapper = $this.find(".swiper-wrapper");

    $wrapper.find(".swiper-slide").each(function () {
      let $slide = $(this);
      let $video = $slide.find(".vg_video");
      let sID = $slide.attr("id");
      let obj = {
        id: sID,
        parent: cID,
        visible: true,
        keywords: getLowerCaseString($video.data("keywords")),
        title: getLowerCaseString($video.find(".vg_title").text()),
        countries: $video.data("countries").toString(),
        html: $slide[0].outerHTML,
      };
      let keywordsArray = $video.data("keywords").split(",");
      keywordsArray.forEach((keyword) => {
        keyword = keyword.trim();
        if (!allKeywords.includes(keyword)) allKeywords.push(keyword);
      });
      allSlides.push(obj);
    });
    // console.log("allSlides", allSlides);

    let slideCount = $wrapper.find(".swiper-slide").length;
    $wrapper.css("width", `${slideCount * 400}px`);

    $(`.btn.category-select[data-uid="${data.uid}"]`).removeAttr("disabled");

    let swiper = new Swiper(`#${id}`, {
      modules: [Navigation, Keyboard, A11y],
      slidesPerView: "auto",
      slidesOffsetBefore: 15,
      slidesOffsetAfter: 15,
      rewind: true,
      watchOverflow: false,
      navigation: {
        nextEl: `#${cID} .swiper-button-next`,
        prevEl: `#${cID} .swiper-button-prev`,
      },
      keyboard: { enabled: true },
      a11y: { enabled: true },
      fadeEffect: { crossFade: true },
      on: {
        afterInit: function () {
          $(`#${cID}`).addClass("slider-init");
          $(`#${cID}`).show();
        },
        slideChangeTransitionEnd: function (swiper) {
          let isLocked = checkSlideVisibility(swiper);
          if (isLocked) {
            swiper.disable();
          } else {
            swiper.enable();
            $(`#${cID} .swiper-button-next`).removeClass("swiper-button-lock");
            $(`#${cID} .swiper-button-prev`).removeClass("swiper-button-lock");
          }
        },
        update: function (swiper) {
          let isLocked = checkSlideVisibility(swiper);
          if (isLocked) {
            swiper.disable();
          } else {
            swiper.enable();
            $(`#${cID} .swiper-button-next`).removeClass("swiper-button-lock");
            $(`#${cID} .swiper-button-prev`).removeClass("swiper-button-lock");
          }
        },
      },
    });

    $(window).on("updateSlider", function () {
      swiper.params.slidesOffsetBefore = vgOptions.before;
      swiper.params.slidesOffsetAfter = vgOptions.after;
      setTimeout(() => swiper.update(), 300);
    });

    $(window).on("resetSlider", function () {
      swiper.params.slidesOffsetBefore = vgOptions.before;
      swiper.params.slidesOffsetAfter = vgOptions.after;
      swiper.slideTo(0, 0);
      setTimeout(() => swiper.update(), 300);
    });
  });

  allKeywords.splice(allKeywords.indexOf(""), 1);
  allKeywords.sort();
  // console.log("allKeywords", allKeywords);

  updateButtonPositions();
  autocomplete(document.getElementById("vg_keywords"), allKeywords);

  // ----------------------------------------------
  // search on category select
  // ----------------------------------------------
  $("#vg_country").on("change", function (e) {
    e.preventDefault();
    let formData = $(this).closest("form").serializeArray();
    let country = parseInt(formData[0].value);
    let keywords = getLowerCaseString(formData[1].value);

    if (isNaN(country) && keywords.length === 0) {
      resetVideos();
    } else {
      filterVideos(keywords, country);
    }
  });

  // ----------------------------------------------
  // search on form submit
  // ----------------------------------------------
  $("#vg_submit")
    .closest("form")
    .on("submit", function (e) {
      e.preventDefault();
      let formData = $(this).serializeArray();
      let country = parseInt(formData[0].value);
      let keywords = getLowerCaseString(formData[1].value);

      if (isNaN(country) && keywords.length === 0) {
        resetVideos();
      } else {
        filterVideos(keywords, country);
      }
    });

  // ----------------------------------------------
  // search on form reset
  // ----------------------------------------------
  $("#vg_reset")
    .closest("form")
    .on("reset", (e) => {
      e.preventDefault();
      resetVideos();
    });

  // ----------------------------------------------
  // filter by category
  // ----------------------------------------------
  $(".btn.category-select").on("click", function (e) {
    let $this = $(this);
    if ($this.hasClass("active")) {
      $this.removeClass("active");
    } else {
      $(".btn.category-select.active").removeClass("active");
      $this.addClass("active");
    }
    filterCategories();
  });

  // ----------------------------------------------
  // modal handling
  // ----------------------------------------------
  $(".vg_button.play").on("click", function (e) {
    let uid = $(this).data("uid");
    let url = `${base}?type=1710230152&video=${uid}`;
    $modalContent.addClass("loading");
    $modal.modal("show");
    fetch(url, { method: "GET" })
      .then((response) => response.json())
      .then((data) => {
        $modalBody.html(data.html);

        let target = $modal.find(".video-play-button").data("target");

        video(target);
        $modal.on("hidden.bs.modal", (e) => $modalBody.html(""));
        $modalContent.removeClass("loading");
        // $modal.find(".video-play-button").click();
      })
      .catch((error) => console.error("Error:", error));
  });
};
